import React from "react"
import makeStyles from "@material-ui/core/styles/makeStyles"
import Paper from "@material-ui/core/Paper"

const useStyles = makeStyles(theme => ({
  root: {},
  Map: {
    boxShadow: theme.shadows[10],
    margin: "auto",
    minHeight: theme.spacing(51.7),
    maxWidth: theme.spacing(44.2),
    maxHeight: theme.spacing(51.7),
    [theme.breakpoints.down("xs")]: {
      minHeight: theme.spacing(30),
      maxWidth: "100%",
      maxHeight: theme.spacing(40),
      marginTop: theme.spacing(4),
      marginBottom: theme.spacing(4),
      boxShadow: "none",
    },
  },
  iframe: {
    width: "100%",
    height: "100%",
    width: "fill-available",
    height: "fill-available",
    border: 0,
  },
}))

export const Map = () => {
  const classes = useStyles()

  return (
    <Paper className={classes.Map}>
      <iframe
        title="Gloone Events business location on google maps"
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3964.2245226633863!2d3.330164450298386!3d6.4932312252929805!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x103b855b35e0970f%3A0xa15cbcf554eb16bd!2sGLOONE%20EVENT%20AND%20CATERING%20SERVICES!5e0!3m2!1sen!2sng!4v1598184074576!5m2!1sen!2sng"
        frameBorder="0"
        className={classes.iframe}
        // allowFullScreen=""
        aria-hidden="false"
        tabIndex={0}
      ></iframe>
    </Paper>
  )
}

export default Map
